import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {combineLatest, Observable, of} from 'rxjs';
import {AuthSelectors} from '../store/selectors';
import {map, tap} from 'rxjs/operators';
import {AuthActions} from '../store/actions';

@Injectable({
  providedIn: 'root'
})
export class AuthByCodeGuardService {
  constructor(private store: Store,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return of(null)
      .pipe(
        map(() => {

          const auth_code = route.params?.code;
          if (auth_code?.length > 0) {
            console.log('AuthByCodeGuardService auth_code: ', auth_code);
            this.store.dispatch(AuthActions.loginByAuthCode({auth_code, url: ''}));
          }

          return false;
        })
      );
  }
}
